import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialog = inject(MatDialog);

  /**
   * Helper to lazy-load dialog components.
   */
  private async openLazyDialog(
    loader: () => Promise<any>,
    exportName: string,
    config?: MatDialogConfig
  ) {
    const module = await loader();
    const component = module[exportName] as ComponentType<unknown>;
    return this.dialog.open(component, config);
  }

  // --- Auth Dialogs ---

  async openLoginDialog() {
    return this.openLazyDialog(
      () => import('../features/auth/login/login.component'),
      'LoginComponent',
      {
        width: '520px',
        maxWidth: '92vw',
        autoFocus: false
      }
    );
  }

  async openRegisterDialog() {
    return this.openLazyDialog(
      () => import('../features/auth/register/register.component'),
      'RegisterComponent',
      {
        width: '520px',
        maxWidth: '92vw',
        autoFocus: false
      }
    );
  }

  // --- Footer/Static Dialogs ---

  async openAboutDialog() {
    return this.openLazyDialog(
      () => import('../features/dialogs/about-dialog/about-dialog'),
      'AboutDialogComponent',
      {
        width: '600px',
        autoFocus: false
      }
    );
  }

  async openSuggestDialog() {
    return this.openLazyDialog(
      () => import('../features/dialogs/suggest-dialog/suggest-dialog'),
      'SuggestDialogComponent',
      {
        width: '720px',
        maxWidth: '90vw',
        autoFocus: false
      }
    );
  }

  async openContactDialog() {
    return this.openLazyDialog(
      () => import('../features/dialogs/contact-dialog/contact-dialog'),
      'ContactDialogComponent',
      {
        width: '600px',
        autoFocus: false
      }
    );
  }
}
